import { useAnomalyStore } from '../stores/anomalyStore'

import { registerSessionReset } from '@/features/auth'

/** Clear account-scoped anomaly data on logout so records never cross tenant boundaries. */
export function registerAnomalySessionReset(): () => void {
  const store = useAnomalyStore()
  return registerSessionReset(() => store.reset())
}
